import React from 'react';
import { TImage } from '../../../components/template';

export const CustomPageImage = React.memo(({ imageUrlMediumAndLarge, imageUrlSmall, altText = '' }) => (
  <TImage renderAs='section' src={imageUrlMediumAndLarge} placeholderSrc={imageUrlSmall} title={altText} />
));
